<template>
<svg width="35" height="35" xmlns="http://www.w3.org/2000/svg">

 <g>
  <title>Layer 1</title>
  <path id="svg_2" d="m11.159,33.931c-9.006,-3.502 -13.466,-13.64 -9.966,-22.648c3.503,-9.005 13.644,-13.467 22.648,-9.962c9.006,3.499 13.466,13.643 9.966,22.646c-3.503,9.006 -13.644,13.465 -22.648,9.964"/>
  <g id="svg_6">
   <path id="svg_3" stroke-linejoin="round" stroke-linecap="round" stroke-width="2.0" stroke="#fff" d="m17.53118,24.81243l0,-8.12499"/>
   <path id="svg_4" fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-width="2.0" stroke="#fff" d="m15.0478,19.00886l2.48338,-2.51526l2.48338,2.51526"/>
   <path id="svg_5" fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-width="2.5" stroke="#fff" d="m22.11517,24.81243l2.93375,0c2.20948,0 4.01099,-1.82464 4.01099,-4.06249c0,-2.23785 -1.80151,-4.06249 -4.01099,-4.06249l-0.49851,0l0,-1.16071c0,-3.84196 -3.08273,-6.96427 -6.87598,-6.96427c-3.41163,0 -6.23995,2.52803 -6.77628,5.83026c-2.72404,0.14045 -4.8957,2.40267 -4.8957,5.19651c0,2.88437 2.30918,5.22321 5.15699,5.22321l1.78776,0"/>
  </g>
 </g>
</svg>
</template>